module.exports = __webpack_public_path__ + "static/media/task_white.54a21c1c.svg";